import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { PagingControl } from '../../../../components/paging-control';
import * as PagingActions from '../../../../store/paging/paging.actions';
import * as BatchesGridActions from '../../../../store/batches/grid/batches.grid.actions';
import { calculatePagingStats, FIRST_PAGE, PAGE_SIZE_100, PAGE_SIZE_250, PAGE_SIZE_500 } from '../../../../services/pagination-service';

const pagingViewName = 'batches.grid';

const BatchesGridPagingContainer = () => {
  const dispatch = useDispatch();

  const pagingStats =
    useSelector((state) =>
      Global.selectPagingViewPagingStats(state, {
        viewName: pagingViewName,
      }),
    ) || calculatePagingStats(FIRST_PAGE, PAGE_SIZE_100, 0);
  const numberSelected = useSelector(Global.selectBatchesSelectedBatches).length;

  const onPageChange = useCallback(
    (page, pageSize) => {
      dispatch(PagingActions.setViewPageAndPageSize(pagingViewName, page, pageSize));
      dispatch(BatchesGridActions.getBatchRows());
    },
    [dispatch],
  );

  return (
    <PagingControl
      {...pagingStats}
      allowablePageSizes={[PAGE_SIZE_100, PAGE_SIZE_250, PAGE_SIZE_500]}
      numberSelected={numberSelected}
      onPageChange={onPageChange}
    />
  );
};

export default BatchesGridPagingContainer;
